import React, { useState } from "react";
import { api } from "@/lib/api";
import { Modal, Label, TextArea, Alert, Button } from "@/components/ui";

export function AppealModal({ eob, onClose, onDrafted }) {
  const [tone, setTone] = useState("assertive");
  const [focus, setFocus] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const submit = async () => {
    setErr(null); setBusy(true);
    try { await api.draftAppeal(eob.id, { tone, focus: focus.trim() || null }); setFocus(""); onDrafted(); }
    catch (e) { setErr(e?.message || "Failed to draft appeal"); }
    finally { setBusy(false); }
  };
  return (
    <Modal open={!!eob} onClose={onClose} title="Draft appeal letter" testid="appeal-modal">
      <p className="text-sm text-subtle mb-3">{eob?.provider} · ${Number(eob?.amount_billed || 0).toFixed(2)}</p>
      <Label>Tone</Label>
      <div className="flex gap-2 mt-2 mb-4">
        {["standard", "assertive"].map((t) => (
          <button key={t} data-testid={`appeal-tone-${t}`} onClick={() => setTone(t)}
            className={`px-4 py-2 rounded-full text-sm font-semibold capitalize border ${tone === t ? "bg-brand text-white border-brand" : "bg-brand-tint text-brand-dark border-line"}`}>{t}</button>
        ))}
      </div>
      <TextArea label="Anything specific to emphasize? (optional)" data-testid="appeal-focus-input" value={focus} onChange={(e) => setFocus(e.target.value)} rows={3}
        placeholder="Mom was in-network. The ER coded it wrong." />
      <Alert testid="appeal-error">{err}</Alert>
      <Button data-testid="generate-appeal-button" onClick={submit} loading={busy} className="w-full">Generate with Claude Sonnet</Button>
      {busy && <p className="text-xs text-subtle text-center mt-3">Claude is drafting your appeal — this can take up to 30 seconds. Please keep this open.</p>}
    </Modal>
  );
}
